import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { ArrowRight, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EastTexasRoots() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="east-texas-roots" ref={ref} className={`dark bg-background text-foreground relative overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="grid min-h-[800px] w-full grid-cols-1 lg:grid-cols-2">
        {}
        <div className="relative h-[500px] w-full overflow-hidden lg:h-auto">
          {}
          <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569013/img/east_texas_landscape_bw.png)] bg-cover bg-center bg-no-repeat grayscale filter contrast-125 brightness-90" />
          
          {}
          <div className="bg-primary/60 absolute inset-0 mix-blend-multiply" />
          <div className="bg-primary/20 absolute inset-0 mix-blend-overlay" />
          
          {}
          <div className="pointer-events-none absolute inset-0 opacity-20 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIi8+CjxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9IiMwMDAiLz4KPC9zdmc+')] [mask-image:linear-gradient(to_bottom,transparent,black)]" />
        </div>

        {}
        <div className="flex flex-col justify-center px-6 py-20 lg:px-20 lg:py-32 xl:px-32">
          <div className="max-w-xl space-y-10">
            {}
            <div className="space-y-4">
              <div className="flex items-center gap-3 text-primary font-mono text-sm tracking-widest uppercase">
                <MapPin className="h-4 w-4" />
                <span>East Texas Native</span>
              </div>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.1] tracking-tight text-white">
                Forged in the <br />
                <span className="text-primary">Rough Country.</span>
              </h2>
            </div>

            <Separator className="bg-border/30 w-24" />

            {}
            <div className="space-y-8 text-lg leading-relaxed text-muted-foreground font-sans font-light">
              <p>
                Shark Bite Land Clearing wasn’t built in a boardroom. It was born directly from the red dirt and thick pine curtains of East Texas. We understand that land here isn't just property—it's a legacy, a livelihood, and a way of life.
              </p>
              <p>
                Under the leadership of <strong className="text-foreground font-medium">Helanie Tresidder</strong>, we bring a level of precision and care that only a local owner-operator can provide. We don't just clear brush; we reclaim potential. Whether it's a sprawling ranch or a family homestead, we treat every acre with the respect it deserves.
              </p>
              <p>
                Our commitment is simple: rugged equipment, honest work, and results that stand the test of time. When you see the Shark Bite equipment roll up, you know the job is getting done right.
              </p>
            </div>

            {}
            <div className="pt-4">
              <Button asChild size="lg" className="h-14 px-8 text-base uppercase tracking-wider font-bold rounded-none border-l-4 border-primary bg-secondary hover:bg-secondary/80 text-white">
                <Link to="/Contact">
                  Start Your Project <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}